import React, { FC, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
    Form, Input, Button, Select, Card, Row, Col, Checkbox,
    Descriptions, Radio, RadioChangeEvent, Collapse
} from "antd";
import queryString, { parse } from "query-string";
import { Message, AntModal } from "../../../../../../utils";
import BookSearchListFilter from "./UnionJournalSearchList.filter";
import BookSearchListListing from "./UnionJournalSearchList.listing";
import BookSearchListPagination from "./UnionJournalSearchList.pagination";
import { useForm } from "../../../../../../hooks/useForm";
import { FackApi } from "../../../../../../api";
import { useTranslation } from "react-i18next";
import { useLang } from "../../../../../../hooks/useLang";
import {
    baecIcon,
    baeraIcon,
    bcsirIcon,
    bnsdocIcon,
    bookSearchIcon,
    businessmanIcon,
    citizenIcon,
    eLearningIcon,
    elearningShapeIcon,
    eTicketingIcon,
    featherIcon,
    grabIconFive,
    grabIconFour,
    grabIconOne,
    grabIconSix,
    grabIconThree,
    grabIconTwo,
    granAppIcon,
    grantFellowshipIcon,
    instituteOrganizationIcon,
    licensingPermitIcon,
    mostIcon,
    nmstIcon,
    organizationCardTitleIcon,
    readmoreIcon,
    researcherIcon,
    researchShapeIcon,
    scientistIcon,
    searchBtnIcon,
    searchIcon,
    seekerCardTitleIcon,
    serviceCardTitleIcon,
    specialResearchIcon,
    studentIcon,
    virtualGalleriesIcon
} from "../../../../../../assets/images/icon";
import { headerBanner } from "../../../../../../assets/images/banner";
import {
    bgshapefive, bgshapefour, bgshapeone, bgshapesix, bgshapethree, bgshapetwo, labMan, nstFellowshipGrant, paginationBulet, scienceBottol
} from "../../../../../../assets/images/pages/home";

import './UnionCatalogueSearchListPage.style.scss';

import {
    FilterOutlined,
    RightOutlined, CaretRightOutlined, DoubleRightOutlined, TableOutlined
} from '@ant-design/icons';

import libraryheadericon from '../../../../../../assets/images/banner/library-header-icon.png';
import libraryproduct from '../../../../../../assets/images/banner/library-product.png';
import bookCoverNotAvailable from '../../../../../../assets/images/banner/book_cover_not_available.jpg';

import librarybookicon from '../../../../../../assets/images/icon/library-book-icon.png';
import libraryauthoricon from '../../../../../../assets/images/icon/library-author-icon.png';
import librarylikeicon from '../../../../../../assets/images/icon/library-like-icon.png';
import libraryorganizationicon from '../../../../../../assets/images/icon/library-organization-icon.png';

import librarysearchsubmiticon from '../../../../../../assets/images/icon/library-search-submit-icon.png';
import bookmarklibraryicon from '../../../../../../assets/images/icon/bookmark-library-icon.png';
import libraryreservericon from '../../../../../../assets/images/icon/library-reserver-icon.png';
import libraryebookicon from '../../../../../../assets/images/icon/library-ebook-icon.png';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import { OpacSearchCatalogueApi } from "../../../../../../api";
import { OpacSearchUnionCatalogueApi } from "../../../../../../api";
import LoadingCircle from '../../../../../../components/Loading/LoadingCircle/LoadingCircle';

import ContextJSX from "../../../../../../components/ContextJsx";
import Breadcrumb from "../../../../../../components/Breadcrumb";
import Header from "../../../../../../components/Header";
import MetaTag from "../../../../../../components/MetaTag";
import { BodyClassName } from "../../../../../../components/BodyClassName/BodyClassName";
import UnionJournalSearchListFilter from './UnionJournalSearchList.filter';
import UnionJournalSearchListListing from './UnionJournalSearchList.listing';
import UnionJournalSearchListPagination from './UnionJournalSearchList.pagination';
import {useErrorHandler} from "../../../../../../hooks/useErrorHandler";
const { Panel } = Collapse;


const onChange = (e: CheckboxChangeEvent) => {
    console.log(`checked = ${e.target.checked}`);
};

const initialState = {
    search: '',
    entity: {},
    entityId: null,
    listData: [],
    filters: {
        document_type: 'journal',
        like: 'contain',
        author: [],
        organization: [],
        status: '',
    },
    pagination: {
        currentPage: 1,
        pageSize: 9,
    },
    totalCount: 0,
    selectedRowKeys: [],
    sort: 'id desc',
    view: null,
    loading: false,
    isShowView: false,
    isShowForm: false,
    isShowReservationForm: false,
    fields: {},
    bulkAction: {
        action: '',
        field: '',
        value: '',
        ids: [] as any,
    },
    totalBookCount: 0,
    totalSubjectCount: 0,
    totalAuthorCount: 0,
    totalOrganizationCount: 0,
}

const UnionJournalSearchListController: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { Option } = Select;
    const { lang, getUserLangUrl, getLangUrl } = useLang();

    const location = useLocation();
    const queryParams = parse(location.search);
    const payload = useRef<any>({});

    const queryState = {
        search: queryParams?.q || initialState.search,
        filters: {
            status: queryParams?.status || initialState.filters.status,
            document_type: queryParams?.document_type || initialState.filters.document_type,
            like: queryParams?.like || initialState.filters.like,
            author: (queryParams?.author as string)?.split(',') || initialState.filters.author,
            organization: (queryParams?.organization as string)?.split(',') || initialState.filters.organization,
        },
        pagination: {
            currentPage: queryParams?.page || initialState.pagination.currentPage,
            pageSize: queryParams?.pageSize || initialState.pagination.pageSize,
        },
        sort: queryParams?.sort || initialState.sort,
        view: queryParams?.view || initialState.view,
        isShowView: queryParams?.isShowView || initialState.isShowView,
        isShowForm: queryParams?.isShowForm || initialState.isShowForm,
        isShowReservationForm: queryParams?.isShowForm || initialState.isShowReservationForm,
        entity: queryParams?.entity || initialState.entity,
        entityId: queryParams?.entityId || initialState.entityId,
    }

    const { formRef, initialValues, resetForm } = useForm({
        search: queryState.search,
        document_type: queryState.filters.document_type,
        like: queryState.filters.like,
        author: queryState.filters.author,
        organization: queryState.filters.organization,
        status: queryState.filters.status
    });
    const { handleErrorMessage, handleSuccessMessage, showErrorMessage } = useErrorHandler();
    const [listData, setListData] = useState<any[]>(initialState.listData);
    const [view, setView] = useState(queryState.view)
    const [search, setSearch] = useState<any>(queryState.search);
    const [filters, setFilters] = useState<any>(queryState.filters);
    const [sort, setSort] = useState(queryState.sort);
    const [pagination, setPagination] = React.useState<any>(queryState.pagination);
    const [totalCount, setTotalCount] = useState(initialState.totalCount);
    const [loading, setLoading] = useState(initialState.loading);
    const [entity, setEntity] = useState(queryState.entity);
    const [entityId, setEntityId] = useState(queryState.entityId);
    const [isShowView, setIsShowView] = useState(queryState.isShowView);
    const [isShowForm, setIsShowForm] = useState(queryState.isShowForm);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState(initialState.selectedRowKeys);
    const [bulkAction, setBulkAction] = React.useState(initialState.bulkAction);
    const [reloadListing, setReloadListing] = useState<number>(Date.now());
    const [reloadView, setReloadView] = useState<number>(Date.now());
    const [reloadForm, setReloadForm] = useState<number>(Date.now());

    const [totalBookCount, setTotalBookCount] = useState(initialState.totalBookCount);
    const [totalSubjectCount, setTotalSubjectCount] = useState(initialState.totalSubjectCount);
    const [totalAuthorCount, setTotalAuthorCount] = useState(initialState.totalAuthorCount);
    const [totalOrganizationCount, setTotalOrganizationCount] = useState(initialState.totalOrganizationCount);

    const [documentType, setDocumentType] = useState(filters.document_type);
    const [keyValue, setkeyValue] = useState(1);

    const [journalCatalougeData, setJournalCatalougeData] = useState<any[]>([]);
    const [libraryCatalougeData, setLibraryCatalougeData] = useState<any[]>([]);
    const [activePanel, setActivePanel] = useState<string>();

    const onChangeKey = (e: RadioChangeEvent) => {
        console.log('radio checked', e.target.value);
        setkeyValue(e.target.value);
    };

    const onSubmit = () => {
        navigate(getLangUrl(lang, '/find-service'));
    }

    useEffect(() => {
        initData();
    }, [search, filters,documentType, sort, pagination, reloadListing])

    useEffect(() => {
        handleUrl();
    }, [entityId, isShowView, isShowForm])

    useEffect(() => {
        if (bulkAction.action !== '') {
            executeBulkAction();
        }
    }, [bulkAction])

    const initData = async () => {
        await handleUrl();
        await handlePayload();
        await loadData();
    }

    const handleShowForm = (value: any, entityId: any) => {
        setIsShowForm(true);
        handleReloadForm();
        setEntity(value);
        setEntityId(entityId);
    };

    const handleShowReserveForm = (value: any, entityId: any) => {
        setEntity(value);
        setEntityId(entityId);
        handleReloadForm();
    };


    const loadData = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            setJournalCatalougeData([]);
            setLibraryCatalougeData([]);
            setActivePanel('');
            if ( (documentType == 'journal' || documentType == 'alldocuments') ) {
                OpacSearchUnionCatalogueApi.getLibraryUnionCatalogueList(payload.current)
                    .then(res => {
                        setListData(res.data.data.results)
                        setTotalCount(res.data.data.meta.totalCount);
                        setTotalBookCount(listData.length);
                        setLoading(false);
                        resolve(res);
                    })
                    .catch(err => {
                        handleErrorMessage(err);
                        setLoading(false);
                        reject(err);
                    });
            } else {
                OpacSearchUnionCatalogueApi.getLibraryWiseJournal(payload.current)
                    .then(res => {
                        setListData(res.data.data.results)
                        setTotalCount(res.data.data.meta.totalCount);
                        setTotalBookCount(listData.length);
                        setLoading(false);
                        resolve(res);
                    })
                    .catch(err => {
                        handleErrorMessage(err);
                        setLoading(false);
                        reject(err);
                    });
            }

        });
    }

    const handleDelete = (value: any, action: any): Promise<any> => {
        return new Promise((resolve, reject) => {
            if (value && action === 'ok') {
                setLoading(true);
                FackApi.delete(value)
                    .then(res => {
                        handleSuccessMessage(res)
                        handleHideView();
                        handleReloadListing();
                        setLoading(false);
                        resolve(res);
                    })
                    .catch(err => {
                        handleErrorMessage(err);
                        setLoading(false);
                        reject(err);
                    });
            }
        });
    }

    const executeBulkAction = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            const payload = {
                ...bulkAction
            }
            FackApi.bulk(payload)
                .then(res => {
                    handleReloadListing();
                    setLoading(false);
                    resolve(res);
                })
                .catch(err => {
                    handleErrorMessage(err);
                    setLoading(false);
                    reject(err);
                });
        });
    };

    const handleUrl = (): void => {
        let urlObject: any = {}

        if (search) {
            urlObject.q = search
        }
        if (filters.status) {
            urlObject.status = filters.status
        }
        if (filters.document_type) {
            urlObject.document_type = filters.document_type
            setDocumentType(filters.document_type);
        }
        if (filters.like) {
            urlObject.like = filters.like
        }
        if (filters.author.length) {
            urlObject.author = filters.author.join(',')
        }
        if (filters.organization.length) {
            urlObject.organization = filters.organization.join(',')
        }
        if (sort !== initialState.sort) {
            urlObject.sort = sort
        }
        if (pagination.currentPage !== initialState.pagination.currentPage) {
            urlObject.page = pagination.currentPage
        }
        if (pagination.pageSize !== initialState.pagination.pageSize) {
            urlObject.pageSize = pagination.pageSize
        }
        if (view !== initialState.view) {
            urlObject.view = view
        }
        if (entityId) {
            urlObject.entityId = entityId
        }
        if (isShowView) {
            urlObject.isShowView = isShowView
        }
        if (isShowForm) {
            urlObject.isShowForm = isShowForm
        }
        if (Object.keys(urlObject).length) {
            navigate({ search: queryString.stringify(urlObject) });
        }
        else {
            navigate(`${location.pathname}`);
        }
    }

    const processFilters = (): string => {
        let filterString = "";
        return filterString
    }

    const processQueryParams = () => {
        let filterString = {};

        // filterString['title'] = 'The Encyclopaedia of Humanities';

        if (filters.status) {
            filterString['status'] = filters.status;
        }

        if (filters.document_type) {
            filterString['document_type'] = filters.document_type;
            setDocumentType(filters.document_type);
        }

        if (filters.like) {
            filterString['like'] = filters.like;
        }

        if (filters.organization.length) {
            filterString['organization'] = filters.organization;
        }

        if (filters.author.length) {
            filterString['author'] = filters.author;
        }

        return filterString
    }

    const processOrderBy = (): string => {
        let orderByString
        if (sort === 'date-desc') {
            orderByString = 'id desc';
        }
        else {
            orderByString = sort;
        }

        return orderByString
    }

    const handlePayload = (): void => {
        payload.current = {
            '$select': '',
            '$search': search,
            '$filter': '',
            '$queryParams': processQueryParams(),
            '$expand': '',
            '$orderby': '',
            '$top': pagination.pageSize,
            '$skip': pagination.pageSize * (pagination.currentPage - 1),
        }
    }

    const onChangeSwitchToggle = (checked: any, record: any) => {
        setEntity(record);

        if (checked === true) {
            setBulkAction({
                ...bulkAction,
                action: 'update_boolean',
                field: 'status',
                value: '1',
                ids: [record.id],
            });
        }
        else {
            setBulkAction({
                ...bulkAction,
                action: 'update_boolean',
                field: 'status',
                value: '0',
                ids: [record.id],
            });
        }
    }

    const handleBulkActions = (action: string) => {
        if (selectedRowKeys.length === 0) {
            showErrorMessage('Please select item(s)');
            return;
        }
        if (action === 'active') {
            setBulkAction({
                ...bulkAction,
                action: 'update_boolean',
                field: 'status',
                value: '1',
                ids: selectedRowKeys,
            });
        }
        else if (action === 'inactive') {
            setBulkAction({
                ...bulkAction,
                action: 'update_boolean',
                field: 'status',
                value: '0',
                ids: selectedRowKeys,
            });
        }
        else if (action === 'delete') {
            AntModal.confirm(t('Delete Example'), t('Are you sure you wish to delete selected examples?'), selectedRowKeys, confirmBulkDelete, 'Delete');
        }
    };

    const confirmBulkDelete = (value: any, action: any) => {
        if (value && action === 'ok') {
            setBulkAction({
                ...bulkAction,
                action: 'delete',
                ids: value,
            });
        }
    };

    const handleActions = (action: string, recordId?: any) => {
        const record = listData.find(item => item.id === Number(recordId));
        setEntity(record);

        if (action === 'view') {
            setEntityId(recordId);
            setIsShowView(true);
        }
        else if (action === 'add') {
            setEntityId(null);
            setIsShowForm(true);
            handleReloadForm();
        }
        else if (action === 'edit') {
            setEntityId(recordId);
            setIsShowForm(true);
            handleReloadForm();
        }
        else if (action === 'delete') {
            AntModal.confirm(t('Delete Example'), t('Are you sure you want to delete this example?'), recordId, handleDelete, 'Delete');
        }
    };

    const handleReset = () => {
        setSearch(initialState.search);
        setFilters({
            document_type: initialState.filters.document_type,
            like: initialState.filters.like,
            author: initialState.filters.author,
            organization: initialState.filters.organization,
            status: initialState.filters.status
        });
        setDocumentType(initialState.filters.document_type);
        setPagination({ currentPage: initialState.pagination.currentPage, pageSize: initialState.pagination.pageSize });
        setSort(initialState.sort);
        setView(initialState.view);
        resetForm();
    };

    const handleReloadListing = () => {
        setReloadListing(Date.now());
    };

    const handleReloadForm = () => {
        setReloadForm(Date.now());
    };

    const handleReloadView = () => {
        setReloadView(Date.now());
    };

    const handleTableChange = (pagination, filters, sorter, extra) => {
        if (sorter.order === 'ascend') {
            setSort(sorter.field + ' asc');
        }
        else if (sorter.order === 'descend') {
            setSort(sorter.field + ' desc');
        }
        else if (sorter.order === undefined) {
            setSort(initialState.sort);
        }
    };

    const handleOnChanged = (fieldName: string, value: any, text?: any) => {
        if (fieldName === 'filter_status') {
            setFilters({
                ...filters,
                status: value,
            });
        }
        else if (fieldName === 'filter_document_type') {
            setFilters({
                ...filters,
                document_type: value,
            });
            setDocumentType(value);
        }
        else if (fieldName === 'filter_like') {
            setFilters({
                ...filters,
                like: value,
            });
        }
        else if (fieldName === 'filter_author') {
            setFilters({
                ...filters,
                author: value,
            });
        }
        else if (fieldName === 'filter_organization') {
            setFilters({
                ...filters,
                organization: value,
            });
        }
        else if (fieldName === 'selected_row_keys') {
            setSelectedRowKeys(value);
        }
        else if (fieldName === 'search') {
            setSearch(value)
        }
        else if (fieldName === 'view_type') {
            setView(value);
        }
        else if (fieldName === 'pagination_change_page_and_size') {
            setPagination({
                ...pagination,
                currentPage: value,
                pageSize: text,
            });
        }
    }

    const handleHideView = () => {
        setIsShowView(false);
        if (isShowForm === false) {
            setEntityId(null);
        }
    };

    const handleHideForm = () => {
        setIsShowForm(false);
        // setEntityId(null);
        // setEntity({});
    };

    const updateListItem = (recordId: any, data: any) => {
        setListData(listData => {
            const index = listData.findIndex(item => item.id === Number(recordId))
            listData[index] = { ...listData[index], ...data };
            return [...listData];
        })
    };

    const handleCallbackFunc = (event: any, action: string, recordId?: any, data?: any) => {
        if (event === null || event === undefined || event === '') {
            event = event ? event : 'singleAction';
        }
        if (event == 'singleAction' && action == 'add') {
            handleActions('add')
        }
        else if (event == 'singleAction' && action == 'edit') {
            handleActions('edit', recordId)
        }
        if (event == 'singleAction' && action == 'view') {
            handleActions('view', recordId)
        }
        else if (event == 'singleAction' && action == 'delete') {
            handleActions('delete', recordId)
        }
        else if (event == 'singleAction' && action == 'hideView') {
            handleHideView();
        }
        else if (event == 'singleAction' && action == 'hideForm') {
            handleHideForm();
        }
        else if (event == 'singleAction' && action == 'reloadView') {
            handleReloadView();
        }
        else if (event == 'singleAction' && action == 'reloadForm') {
            handleReloadForm();
        }
        else if (event == 'singleAction' && action == 'reloadListing') {
            handleReloadListing();
        }
        else if (event == 'singleAction' && action == 'resetListing') {
            handleReset();
        }
        else if (event == 'singleAction' && action == 'updateListItem') {
            updateListItem(recordId, data);
        }
        else if (event == 'bulkAction' && action) {
            handleBulkActions(action)
        }
    }

    return (
        <>
            <ContextJSX>
                <BodyClassName className={`about-us-body-class`} />
                <MetaTag>
                    <MetaTag.Title>{t('National Union Catalogue')}</MetaTag.Title>
                    {/* <MetaTag.Tag name="description" content="About the Ministry of Science & Technology" /> */}
                </MetaTag>
                <Header>
                    <Header.PageTitle>{t('National Union Catalogue')}</Header.PageTitle>
                </Header>
                <Breadcrumb>
                    <Breadcrumb.Item>{t('National Union Catalogue')}</Breadcrumb.Item>
                </Breadcrumb>
            </ContextJSX>

            {loading ? <LoadingCircle /> : null}

            <div className="library-page-content">
                <div className='library-header pt-5 pb-3'>
                    <p className='h4 text-center mb-0'>{t('BANGLADESH NATIONAL SCIENTIFIC AND TECHNICAL DOCUMENTATION CENTRE')}</p>
                    <h2 className='h2 text-center mt-2 mb-2 fw-normal'>{t('NATIONAL UNION CATALOGUE')}</h2>
                </div>

                <UnionJournalSearchListFilter
                    filters={filters}
                    handleOnChanged={handleOnChanged}
                    librarysearchsubmiticon={librarysearchsubmiticon}
                    onChangeKey={onChangeKey}
                    keyValue={keyValue}
                    filterLike={filters.like}
                />

                <UnionJournalSearchListListing
                    libraryproduct={libraryproduct}
                    libraryreservericon={libraryreservericon}
                    libraryebookicon={libraryebookicon}
                    bookCoverNotAvailable={bookCoverNotAvailable}
                    loading={loading}
                    listData={listData}
                    setEntity={setEntity}
                    reloadListing={reloadListing}
                    selectedRowKeys={selectedRowKeys}
                    onChangeSwitchToggle={onChangeSwitchToggle}
                    handleOnChanged={handleOnChanged}
                    handleTableChange={handleTableChange}
                    handleCallbackFunc={handleCallbackFunc}
                    handleShowForm={handleShowForm}
                    handleShowReserveForm={handleShowReserveForm}
                    documentType={documentType}
                    journalCatalougeData={journalCatalougeData}
                    setJournalCatalougeData={setJournalCatalougeData}
                    libraryCatalougeData={libraryCatalougeData}
                    setLibraryCatalougeData={setLibraryCatalougeData}
                    activePanel={activePanel}
                    setActivePanel={setActivePanel}
                />

                <UnionJournalSearchListPagination
                    pagination={pagination}
                    totalCount={totalCount}
                    handleOnChanged={handleOnChanged}
                />

            </div>


        </>

    );
}

export default UnionJournalSearchListController;
